var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-system-bar',{style:(_vm.styleComputed),attrs:{"color":_vm.colorComputed,"fixed":"","height":_vm.height}})
}
var staticRenderFns = []

export { render, staticRenderFns }